import type { ToolResultItem } from '@elara/client-core/chat/tool-badges/types';

import type { IconName } from '#ui/MaterialIcon.js';

import { useState } from 'react';

import { formatToolDataSources } from '@elara/client-core/chat/tool-badges/view-model';
import { cn } from '@elara/client-core/lib/utils';

import { IconSizes, MaterialIcon } from '#ui/MaterialIcon.js';

import { ToolResultLinkList } from './ToolResultLinkList.js';

/** Dropdown-style tool badge: icon + label on a button row, expands to a list of result links. */
export function ExpandableResultsBadge({
  label,
  icon,
  items,
  dataSource,
  className,
}: {
  label: string;
  icon: IconName;
  items: ToolResultItem[];
  dataSource?: string | readonly string[];
  className?: string;
}) {
  const [isOpen, setIsOpen] = useState(false);
  const dataSourceText = formatToolDataSources(dataSource);
  return (
    <div className={cn('w-full', className)}>
      <button
        type="button"
        onClick={() => setIsOpen((v) => !v)}
        className="flex items-center gap-2 text-sm text-muted-foreground/70 w-full cursor-pointer hover:text-foreground transition-colors"
      >
        <MaterialIcon icon={icon} size={IconSizes.xs} className="shrink-0" />
        <span className="truncate">{label}</span>
        <MaterialIcon
          icon="keyboard_arrow_down"
          size={IconSizes.xs}
          className={cn('shrink-0 transition-transform -ml-1', isOpen && 'rotate-180')}
        />
      </button>
      {isOpen && (
        <div className="mt-2">
          <ToolResultLinkList items={items} itemIcon={icon} />
          {dataSourceText && (
            <div className="mt-2 px-1 text-2xs text-muted-foreground/70">Sourced from {dataSourceText}</div>
          )}
        </div>
      )}
    </div>
  );
}
